import * as S from './ProjectAddress.styled'

const ProjectAddress = ({ address }) => {
  return <S.ProjectAddress>{address}</S.ProjectAddress>
}

export default ProjectAddress
